export const faturaTypes = {
  SATIS_FATURASI: "Satış Faturası",
  ALIS_FATURASI: "Alış Faturası",
  ALIS_IADE_FATURASI: "Alış İade Faturası",
  SATIS_IADE_FATURASI: "Satış İade Faturası",
};
